
// const BASE_URL = "http://sunboundvillas.test";
const BASE_URL = "https://api.sunboundvillas.com";

const BASE = {
    BASE_API_URL : BASE_URL,
    // Fallback if the admin exchange-rate setting cannot be loaded.
    GBP_EUR_BANK_CHARGE_PERCENT: 0,
    // REACT_APP_RECAPTCHA_SITE:"6Lc-eRIrAAAAAAuxKHh9FJOFQODtwVJsgKpqZCk_",
    REACT_APP_RECAPTCHA_SITE:"6LcMtm4tAAAAAHqmSUFNlUDOEO9OcDqiHXfcd-CD",
    BASE_IMAGES_PATH : "https://api.sunboundvillas.com/images",
    LIVE_SITE_URL : "https://www.sunboundvillas.com",
}

export default BASE